export default {
  lucky: {
    prizeAgain: '다시 돌리기',
    prizeThanks: '다음 기회에',
    remainingChance: '남은 횟수',
    task: '미션',
    deposit: '입금',
    wager: '베팅',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: '카드 수집',
    puzzleRound: '라운드 {current}/{total}',
    puzzleReward: '완성 보상 {amount}',
    redeem: '교환하기',
    redeemSuccess: '교환에 성공했습니다',
    redeemSuccessWithReward: '교환에 성공했습니다! {amount} {currency}을(를) 획득했습니다',
    redeemFailed: '교환에 실패했습니다',
    notComplete: '아직 완성되지 않아 교환할 수 없습니다',
    drawFailed: '추첨에 실패했습니다. 다시 시도해 주세요',
    gainLetter: '축하합니다! 글자 {letter}을(를) 획득했습니다',
    gainBlock: '축하합니다! 그림 {blockNo}을(를) 획득했습니다',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: '초대하기',
    claimReward: '받기',
    noChest: '보물상자 없음',
    claimSuccess: '{count}개의 보물상자를 받았습니다. {amount} {currency}',
    modalTitle: '보물상자',
    modalSubtitle: '좌우로 스와이프하여 모두 보기',
    chipTodayClaimed: '오늘 받음',
    chipClaimable: '받을 수 있음',
    chipLocked: '잠김',
    totalClaimedCount: '받은 보물상자 총 개수',
    totalClaimedAmount: '받은 총 금액',
    chestUnit: '개',
    claimAll: '한 번에 받기',
    goInvite: '초대하러 가기',
    claimSingleSuccess: '{amount} {currency} 받았습니다',
    labelClaimed: '받음',
    labelClaimable: '받을 수 있음',
    labelLocked: '잠김',
  },
}
